export default __webpack_public_path__ + "static/media/6.d53d01f7.jpg";